const RETREAT_DATE_PATTERN = /(?:Sonntag,\s*)?13\.\s*Dezember\s*2026/g;

export function normalizeLandingPageText(root) {
  if (!root) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let textNode = walker.nextNode();

  while (textNode) {
    const normalizedText = textNode.nodeValue
      .replace(RETREAT_DATE_PATTERN, '')
      .replace(/([.,;])(?=\S)/g, '$1 ');

    if (normalizedText !== textNode.nodeValue) {
      textNode.nodeValue = normalizedText;
    }

    textNode = walker.nextNode();
  }
}